module.exports = __webpack_public_path__ + "img/three-iphones-mobile@2x.13a3872b.png";